// Add your JS customizations here
jQuery(document).ready(function($) { 

	//inizialize WOW
	new WOW().init();

	//enables Font Awesome pseudo elements
	window.FontAwesomeConfig = {
		searchPseudoElements: true
	}

	//Variables
	let wSize = $( window ).width();
	const $root = $( 'html, body' );
	let topHeader = $('.top-menu-sidebar ');
	let topheaderHeight = $( topHeader ).outerHeight();
	let open_sub = $('.open-sub');

		//add active class to body
	$( 'body' ).addClass( 'active' )

	$('.header_trigger').css( 'margin-top', topheaderHeight );

	//Submenus
	$(open_sub).click(function(){
		let target = $(this).find('a').attr('href');
		$('.submenus').not(target).removeClass('show');
		$(target).toggleClass('show');
	});

	$('.submenus .close').click(function(){
		$('.submenus').removeClass('show');
	});

	if ( wSize >= 992 ) {
		$( '.match-height' ).matchHeight();
	}else{
		$( '.match-height_mob' ).matchHeight();
		//Menu Mob
		$( '.hamburger' ).click( function( e ) {
			e.preventDefault();
			$( this ).toggleClass( 'is-active' );
			$( 'body, html' ).toggleClass( 'modal-open' );
			$( '.main-menu-wrapper-mob' ).fadeToggle( 600 );
			if( $('.submenus').hasClass( 'show' ) ){
				$('.submenus').removeClass('show');
			}
		} );
	}

		//Smap images evey 4 seconds

		let index = 0;
		const imgElement = [...document.querySelectorAll('.swap__img') ];
		let bwImg = imgElement[0];
		let colImg = imgElement[1];
		function ChangeImage(){
			colImg.classList.toggle('hidden');
		}
		setInterval(ChangeImage, 4000);


		//let vimeo_video = document.querySelector( '#vimeo-video-wrapper' );
		 // - audio muted/unmuted 
	    let isAuidoMuted = true;
	    let isVideoAutoplay = true;
	   	let blandy_video_container = $('#blandy_video_container');
		let blandy_iframe = $('#blandy_video_container iframe');
	    
		let callback = ( entries, observer ) => {
			entries.forEach( entry => {
				//var vimeo_video = new Vimeo.Player('blandy_video_container');
			    
   				//vimeo_video.play();
				//blandy_iframe = entry.isIntersecting ? 'play' : 'stop';

				if (isVideoAutoplay === true) {
			      $(blandy_video_container).attr('data-video-is-playing', true);
			      $(blandy_iframe).vimeo('play');

			    }
			    else {
			      $(blandy_video_container).attr('data-video-is-playing', false);
			      $(blandy_iframe).vimeo('pause');
			    }
			} )
		}

		let observer = new IntersectionObserver( callback, {
			threshold: [ 0.25 ] // If 50% of the element is in the screen, we count it!
			// Can change the thresholds based on your needs. The default is 0 - it'll run only when the element first comes into view
		} );

		//array of IDs che vuoi vengano triggered once on viewport
		[ 'range-dentistry', 'div-1' ].forEach( d => {
			const div = document.getElementById( d );
			if ( div ) observer.observe( div );
		} );


	if( $( 'body').hasClass('page-template-home-page') ){

		let caring_dentistrySwap_img = $('#caring-dentistry .swap__img.img_black').outerHeight();
		let caringBox = $('#caring-dentistry .content-box').outerHeight();

		let quick_imgWidth = $('.quick_img').outerWidth();
		let quick_imgHeight = $('.quick_img').outerHeight();

		let caringH = caring_dentistrySwap_img + caringBox;

		if ( wSize >= 992 ) {
			$('#quicklinks').height(quick_imgHeight);
			$('#quicklinks .overlay').height(quick_imgHeight);
			$('.overlay_white').height(quick_imgHeight);
			$('#caring-dentistry').height(caring_dentistrySwap_img);
		}

		$('.quicklink').hover( function(){

	      $(this).addClass("active");  //Add the active class to the area is hovered
	 		 }, function () {
	      $(this).removeClass("active");

			});
			
		}

	if( $( 'body').hasClass('single-treatment') 
		|| $( 'body').hasClass('page-template-our-ethos') 
		|| $( 'body').hasClass('page-template-thecnology')
		|| $( 'body').hasClass('page-template-safety')
		|| $( 'body').hasClass('page-template-team')
		
		){
		let LeftSwap_img = $('.img-left_right box_top .bw_col_swap_img').outerHeight();
		if ( wSize >= 992 ) {
			const viewHeight = $(window).width()*0.44270; //850x -> 44.270vw
			$('.img-left_right').height(viewHeight);
			$('.bw_col_swap_img').height(viewHeight);
		}
		//scroll to sections
		$('.anchors li a').on('click', function (e) {
			e.preventDefault();

			let sectionID = $(this).attr('href');

			var position = $(sectionID).offset().top - $(topHeader).outerHeight(false);

			$('html, body').animate({ scrollTop: position }, 250);

		});

		$( '.anchors_mob .toggle' ).click( function( e ) {
			e.preventDefault();
			var $this = $( this );
			console.log($this);
			if ( $this.parents( '.accordion' ).find( '.inner' ).hasClass( 'show' ) ) {
				$this.parents( '.accordion' ).find( '.inner' ).removeClass( 'show' );
				$this.parents( '.accordion' ).find( '.inner' ).slideUp( 350 );
				$this.parents( '.accordion' ).removeClass( 'open' );
				$this.removeClass( 'active' );
				$this.find( 'span' ).html( '<i class="fa-regular fa-arrow-down"></i>' );
			} else {
				$( '.accordion' ).removeClass( 'open' );
				$( '.inner' ).removeClass( 'show' );
				$( '.inner' ).slideUp( 350 );
				$( '.accordion .toggle .arrow_bt span' ).html(
					' <i class="fa-regular fa-arrow-down"></i>' );
				$this.parents( '.accordion' ).find( '.inner' ).addClass( 'show' );
				$this.parents( '.accordion' ).find( '.inner' ).slideDown( 350 );
				$this.parents( '.accordion' ).addClass( 'open' );
				$this.addClass( 'active' );
				$this.find( 'span' ).html( '<i class="fa-regular fa-arrow-up"></i>' );
			}
		} );
	}


	//ON RESIZE
	
	$( window ).on( 'resize', function() {
		let topheaderHeight = $( topHeader ).outerHeight();
		$('.header_trigger').css( 'margin-top', topheaderHeight );

		let caring_dentistrySwap_img = $('#caring-dentistry .bw_col_swap_img').outerHeight();
		let caringBox = $('#caring-dentistry .content-box').outerHeight();

		let quick_imgWidth = $('.quick_img').outerWidth();
		let quick_imgHeight = $('.quick_img').outerHeight();

		let caringH = caring_dentistrySwap_img + caringBox;

		if ( wSize >= 992 ) {
			$('#quicklinks').height(quick_imgHeight);
			$('#quicklinks .overlay').height(quick_imgHeight);
			$('#caring-dentistry').height(caring_dentistrySwap_img);
		}
	} );

});
